import { LuInfo } from "react-icons/lu";

export default function ListPageHeader({ eyebrow, title, subtitle, info, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
      <div>
        {/* {eyebrow && (
          <div className="inline-flex items-center gap-2 mb-2">
            {eyebrow.icon && (
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-[var(--secondary-color)]/10 text-[var(--secondary-color)]">
                {eyebrow.icon}
              </span>
            )}
            {eyebrow.label && (
              <span className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                {eyebrow.label}
              </span>
            )}
          </div>
        )} */}
        {title && (
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">
            {title}
          </h1>
        )}
        {subtitle && (
          <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
        )}
        {info && (
          <p className="mt-1 inline-flex items-start gap-1.5 text-xs text-blue-700">
            <LuInfo size={13} className="mt-px shrink-0" />
            <span>{info}</span>
          </p>
        )}
      </div>
      {actions && (
        <div className="self-start sm:self-auto inline-flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
}
